import { Eye, EyeOff } from "lucide-react";


export function InputPassword({
  label,
  value,
  setValue,
  showPassword,
  setShowPassword,
  isLoading,
}: any) {
  return (
    <div>
      <label className="block text-[14px] mb-2">{label}</label>

      <div className="relative">
        <input
          type={showPassword ? "text" : "password"}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          disabled={isLoading}
          className="w-full box-border px-4 py-3 border rounded-[10px]"
        />

        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-3 top-1/2 -translate-y-1/2"
        >
          {showPassword ? <EyeOff /> : <Eye />}
        </button>
      </div>
    </div>
  );
}